var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { millisecondToDuration, millisecondToISODate, millisecondToLongDuration } from '../../common/utils';
import AutoTruncatedLabel from '../../labels/components/AutoTruncatedLabel';
import { useAccurityTimezone } from '../../timezoneProvider/AccurityTimezoneProvider';
import { createReactTooltip } from '../../common/tooltip';
var getContent = function (format, value, name, timezone) {
    if (format === void 0) { format = 'TEXT'; }
    switch (format) {
        case 'HTML':
            return React.createElement("div", { dangerouslySetInnerHTML: { __html: "" + value } });
        case 'DATE':
            return millisecondToISODate(value, timezone);
        case 'TIME':
            return millisecondToDuration(value);
        case 'LONG_DURATION':
            return millisecondToLongDuration(value);
        case 'TRUNCATED':
            return React.createElement(AutoTruncatedLabel, { id: "staticField-" + name, value: "" + value });
        default:
            return "" + value;
    }
};
var StaticField = function (_a) {
    var name = _a.name, label = _a.label, className = _a.className, inverted = _a.inverted, value = _a.value, _b = _a.format, format = _b === void 0 ? 'TEXT' : _b, style = _a.style, tooltip = _a.tooltip;
    var timezone = useAccurityTimezone();
    var _c = createReactTooltip(tooltip, 'staticField-' + name), tooltipAnchorParams = _c.tooltipAnchorParams, tooltipElement = _c.tooltipElement;
    return (React.createElement("div", __assign({ className: classNames('staticField', className, { inverted: inverted }), style: style }, tooltipAnchorParams),
        tooltipElement,
        React.createElement("div", { className: 'staticField__contentWrapper' },
            React.createElement("label", null, label),
            React.createElement("div", { className: 'staticField__content' }, getContent(format, value, name, timezone)))));
};
export default StaticField;
//# sourceMappingURL=StaticField.js.map